import { defineMessages } from 'react-intl';

const messages = defineMessages({
  pageHeader: {
    description: 'header text on the USPS pickups page/grid',
    defaultMessage: 'USPS Pickups',
    id: 'JLZ6fK',
  },
  pageSubheader: {
    description: 'subheader text on the USPS pickups page/grid',
    defaultMessage: "If your USPS shipment's ship date doesn't match the pickup date, we recommend scheduling a Manual Pickup",
    id: 'oaop1b',
  },
  schedulePickupHeader: {
    description: 'USPS Pickup Page Header',
    defaultMessage: 'Schedule Pickup for',
    id: 'GTGBMs',
  },
  alreadySecheduledPickupHeader: {
    description: 'USPS Pickup Page Scheduled Header',
    defaultMessage: 'A Pickup has already been scheduled for',
    id: '0W6jgr',
  },
  reminderText: {
    description: 'USPS Pickup Page Pickup Reminder Text',
    defaultMessage: 'Please note! You have a pickup scheduled for today.',
    id: 'vyF59O',
  },
  serviceSectionHeader: {
    description: 'USPS Pickup Page Service Section Header',
    defaultMessage: 'Number of services',
    id: '+B+oY0',
  },
  detailsSectionHeader: {
    description: 'USPS Pickup Page Details Section Header',
    defaultMessage: 'Total Weight (Lbs) and Pickup Details',
    id: 'VLQ4BB',
  },
  addressSectionHeader: {
    description: 'USPS Pickup Page Address Section Header',
    defaultMessage: 'Pickup Address',
    id: '51cEzk',
  },
  totalWeightPickupLabel: {
    description: 'USPS Pickup Page Total Weight Label',
    defaultMessage: 'Total weight',
    id: 'JbjY58',
  },
  pickupLocationPickupLabel: {
    description: 'USPS Pickup Page Pickup Location Label',
    defaultMessage: 'Pickup location',
    id: 'oBe8nB',
  },
  pickupLocationDropdownPlaceholder: {
    description: 'USPS Pickup Page Pickup Location Dropdown Placeholder',
    defaultMessage: 'Select a location',
    id: 'LalevC',
  },
  specialInstructionPickupLabel: {
    description: 'USPS Pickup Page Special Instruction Label',
    defaultMessage: 'Special instructions',
    id: 'PsxEXx',
  },
  firstNamePickupLabel: {
    description: 'USPS Pickup Page First Name Label',
    defaultMessage: 'First Name',
    id: 'bnbL8l',
  },
  lastNamePickupLabel: {
    description: 'USPS Pickup Page Last Name Label',
    defaultMessage: 'Last Name',
    id: '2K86EL',
  },
  companyPickupLabel: {
    description: 'USPS Pickup Page Company Label',
    defaultMessage: 'Company',
    id: 'xzT58F',
  },
  pickupHelperText: {
    description: 'USPS Pickup Page Helper Text',
    defaultMessage:
      'USPS pickups are free if made part of your delivery.{lineBreak}Submit this form before 2am (CST) for next USPS business day pickup.',
    id: 'a851DL',
  },
  boldHelperText: {
    description: 'USPS Pickup Page Bold Helper Text',
    defaultMessage: 'Only qualifying shipments with a “Ship Date” of that day will be eligible and counted above.',
    id: '+wSOTr',
  },
  requestButtonText: {
    description: 'USPS Pickup Page Request Button',
    defaultMessage: 'Request pickup',
    id: '67JsO1',
  },
  cancelButtonText: {
    description: 'USPS Pickup Page Cancel Button',
    defaultMessage: 'Cancel pickup',
    id: 'TXmZvG',
  },
  tooltipContent: {
    description: 'USPS Pickup Page Tooltip Content',
    defaultMessage:
      'Your pickup date may differ depending on your local post office. The scheduled pickup date will appear after you’ve submitted a request.',
    id: 'oYbjPW',
  },
});

export default messages;
